import React, { Component, Fragment } from 'react'

import Header from './common/Header'
import Footer from './common/Footer'

import Bg_1 from 'static/images/download_banner.jpg'
import Bg_2 from "static/images/app_banner.jpg";
import xs1 from 'static/images/1_xs.png'
import xs2 from 'static/images/2_xs.png'
import xs3 from 'static/images/3_xs.png'

class AppIndex extends Component {
    render(){
        return (
            <div className="app-intro-page">
                <Header />
                <main role="main">
                    <div className="fix-background" style={{backgroundImage: `url(${Bg_2})`}}>
                        <div className="container">
                            <div className="row align-items-center">
                                <div className="col-md-8 offset-md-2 text-center">
                                    <h1 className="display-4 font-weight-bold text-white d-inline-block mt-2">
                                        全球酒迷
                                        <br />
                                        必備葡萄酒 APP
                                    </h1>
                                    <h5 className="text-white d-inline-block font-weight-light mb-0">
                                        藏酒管理功能、品酒社交與美酒查詢的全方位服務
                                    </h5>
                                </div>
                            </div>
                        </div>
                    </div>

                    <div className="bg-white">
                        <div className="container container-padding">
                            <div className="row">
                                <div className="col-md-10 offset-md-1 text-center">
                                    <h3 className="section-title">
                                        Cellwine
                                        <br />
                                        不只懂酒，更懂你
                                    </h3>
                                    <p style={{fontWeight: '300'}}>
                                        掃描葡萄酒、管理虛擬酒窖、分享你的葡萄酒品飲紀錄和葡萄酒評分
                                    </p>
                                </div>
                            </div>
                        </div>
                    </div>

                    <div className="app-wrap">
                        <div className="parallex-wrap dark-bg">
                            <div className="parallex parallex-photo app-img img-1">
                                <div className="app-img-content">
                                    <h1 className="text-white pb-3">
                                        身為收藏家
                                    </h1>
                                    <h4 className="text-white pb-3" style={{ fontWeight: '300'}}>
                                        <span className="underline font-weight-bold">
                                            輕鬆拍下酒標
                                        </span>
                                        ，立刻加入酒窖管理。
                                        <br />

                                        建立

                                        <span className="underline font-weight-bold">
                                            多個酒窖
                                        </span>，完全掌握藏酒位置！
                                        <br />
                                        管理

                                        <span className="underline font-weight-bold">
                                            藏酒價格與數量
                                        </span>
                                        ，多個酒窖也不麻煩；
                                        <br />
                                        <span className="underline font-weight-bold">
                                            最新的藏酒市價與趨勢參考
                                        </span>，一次擁有。
                                    </h4>

                                    <h4 className="text-white" style={{ fontWeight: '300' }}>
                                        <ul>
                                            <li>
                                                拍照立即管理
                                            </li>
                                            <li>
                                                可多個酒窖
                                            </li>
                                            <li>
                                                藏酒價格 / 數量管理
                                            </li>
                                            <li>
                                                掌握最新市價趨勢
                                            </li>
                                        </ul>
                                    </h4>
                                    <img className="mobile-img-display img-fluid" src={xs1} alt="" />
                                </div>
                            </div>
                        </div>
                    </div>

                    <div className="app-wrap">
                        <div className="parallex-wrap dark-bg">
                            <div className="parallex parallex-photo app-img img-3">
                                <div className="app-img-content">
                                    <h1 className="text-white pb-3">
                                        身為愛好者
                                    </h1>
                                    <h4 className="text-white pb-3" style={{ fontWeight: '300' }}>
                                        專業食物搭配建議、適飲溫度、專家推薦⋯⋯等，
                                        <br />
                                        所有資訊都在這裡，自己喜好最重要！
                                        <br />
                                        選單式懶人紀錄法，<span className="underline font-weight-bold">評分、口感與香氣</span>一次蒐集。
                                        <br />
                                        珍惜品酒快樂時光，透過<span className="underline font-weight-bold">品飲時刻</span>通通記下來！
                                        <br />
                                        隨時查找，記憶完整再現！
                                    </h4>

                                    <h4 className="text-white" style={{ fontWeight: '300' }}>
                                        <ul>
                                            <li>
                                                開瓶品飲建議
                                            </li>
                                            <li>
                                                品酒筆記
                                            </li>
                                            <li>
                                                紀錄分享
                                            </li>
                                        </ul>
                                    </h4>
                                    <img className="mobile-img-display img-fluid" src={xs2} alt="" />
                                </div>
                            </div>
                        </div>
                    </div>

                    <div className="app-wrap">
                        <div className="parallex-wrap dark-bg">
                            <div className="parallex parallex-photo app-img img-4">
                                <div className="app-img-content">
                                    <h1 className="text-white pb-3">
                                        身為探索家
                                    </h1>
                                    <h4 className="text-white pb-3" style={{ fontWeight: '300' }}>
                                        不知道該不該買那支酒？
                                        <br />
                                        您不止可以<span className="underline font-weight-bold">立刻詢問全世界酒友</span>獲得即時回覆，
                                        <br />
                                        也可以變身成為<span className="underline font-weight-bold">推薦達人</span>，
                                        <br />
                                        無時無刻交流葡萄酒喜好。
                                        <br />
                                        透過追蹤全世界葡萄酒達人，
                                        <br />
                                        瀏覽<span className="underline font-weight-bold">全球酒友的品飲時刻</span>，
                                        <br />
                                        即時互動零距離，探索酒款不設限！
                                    </h4>

                                    <h4 className="text-white" style={{ fontWeight: '300' }}>
                                        <ul>
                                            <li>
                                                開瓶品飲建議
                                            </li>
                                            <li>
                                                品酒筆記
                                            </li>
                                            <li>
                                                紀錄分享
                                            </li>
                                        </ul>
                                    </h4>
                                    <img className="mobile-img-display img-fluid" src={xs3} alt="" />
                                </div>
                            </div>
                        </div>
                    </div>

                    <div className="bg-white">
                        <div className="container">
                            <div className="row">
                                <div className="col-md-4 col-xs-6 text-center" style={{ padding: '20px 0' }}>
                                    <p style={{ fontWeight: '400', marginBottom: '0' }}>Wineblots</p>
                                    <h3 style={{ fontWeight: 'bold', marginTop: '5px' }}>「葡萄酒迷必備」</h3>
                                </div>
                                <div className="col-md-4 col-xs-6 text-center" style={{ padding: '20px 0' }}>
                                    <p style={{ fontWeight: '400', marginBottom: '0' }}>App Store</p>
                                    <h3 style={{ fontWeight: 'bold', marginTop: '5px' }}>4.5 顆星好評</h3>
                                </div>
                                <div className="col-md-4 col-xs-6 text-center" style={{ padding: '20px 0' }}>
                                    <p style={{ fontWeight: '400', marginBottom: '0' }}>Google Play</p>
                                    <h3 style={{ fontWeight: 'bold', marginTop: '5px' }}>4.1 顆星推薦</h3>
                                </div>
                            </div>
                        </div>
                    </div>

                    <div className="fix-background app-download" style={{ backgroundImage: `url(${Bg_1})` }}>
                        <div className="container">
                            <div className="row align-items-center">
                                <div className="col-md-8 offset-md-2 text-center">
                                    <h1 className="font-weight-bold text-white d-block mt-2">
                                        立即下載
                                    </h1>
                                    <h5 className="text-white d-block font-weight-light mb-3">
                                        紀錄是無法取代的收藏品
                                    </h5>
                                </div>
                            </div>
                            <div className="row">
                                <div className="col-8 offset-2">
                                    <div className="row">
                                        <div className="col-md-6">
                                            <a className="d-inline-block mx-auto"
                                                href="https://itunes.apple.com/tw/app/cellwine/id1229068303?mt=8"
                                                target="_blank">
                                                <img style={{ marginBottom: '30px' }} className="img-fluid"
                                                    src="https://imgur.com/xIbvCxk.png" alt="" />
                                            </a>
                                        </div>
                                        <div className="col-md-6">
                                            <a className="d-inline-block mx-auto"
                                                href="https://play.google.com/store/apps/details?id=com.gcourage.cellwine&hl=zh_TW"
                                                target="_blank">
                                                <img style={{ marginBottom: '30px' }} className="img-fluid"
                                                    src="https://imgur.com/6F2P5cD.png" alt="" />
                                            </a>
                                        </div>
                                    </div>
                                </div>
                            </div>
                        </div>
                    </div>
                </main>
                <Footer />
            </div>
        )
    }
}

export default AppIndex
